import { render, staticRenderFns } from "./certificate-list.vue?vue&type=template&id=7ceb1dd5&scoped=true&"
import script from "./certificate-list.vue?vue&type=script&lang=js&"
export * from "./certificate-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ceb1dd5",
  null
  
)

export default component.exports